import { bulkZipUrl } from "./api";

// "Download all as ZIP" — fixed bar at the bottom of the album page.
// The server caps total bytes (50 GB by default) and file count (5000),
// so this disables the button when the share clearly exceeds either.

const BULK_HARD_CAP_BYTES = 50 * 1024 * 1024 * 1024; // mirror env default
const BULK_HARD_CAP_FILES = 5000;

export function BulkDownloadBar(props: {
  token: string;
  totalBytes: number;
  itemCount: number;
}) {
  const tooBig =
    props.totalBytes > BULK_HARD_CAP_BYTES ||
    props.itemCount > BULK_HARD_CAP_FILES;
  const href = bulkZipUrl(props.token);
  return (
    <div className="sticky bottom-3 mt-6 flex justify-center">
      <a
        href={tooBig ? undefined : href}
        aria-disabled={tooBig}
        title={
          tooBig
            ? "Bulk download is unavailable for shares this large — download files individually."
            : undefined
        }
        className={`rounded-full bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium px-5 py-2 shadow-lg ${
          tooBig ? "pointer-events-none opacity-50" : ""
        }`}
      >
        Download all as ZIP
      </a>
    </div>
  );
}
